import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, of } from 'rxjs';
import { User } from 'app/core/services/auth/user.types';
import { PermissionService } from 'app/core/permission/permission.service';
import { StorageService } from 'app/core/auth/storage.service';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    constructor(
        private _httpClient: HttpClient,
        private _permissionService: PermissionService,
        private _storageService: StorageService,
    ) {}

    // Setter & getter for user
    set user(value: User) {
        this._permissionService.loadFromUser(value);
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    /**
     * Get the current logged in user data (dari localStorage)
     */
    get(): Observable<User> {
        const userStr = localStorage.getItem('user');
        const isDevSession = localStorage.getItem('dev_session') === 'true';

        if (userStr) {
            try {
                let user: User;
                if (isDevSession) {
                    user = JSON.parse(userStr);
                } else {
                    // Coba plain JSON dulu, jika gagal decrypt via AES
                    try {
                        user = JSON.parse(userStr);
                    } catch {
                        user = JSON.parse(
                            this._storageService.decryptionAES(userStr),
                        );
                    }
                }

                if (user) {
                    this._permissionService.loadFromUser(user);
                    this._user.next(user);
                    return of(user);
                }
            } catch (e) {
                console.warn(
                    '[UserService] Failed to parse user from localStorage',
                    e,
                );
            }
        }

        // Default fallback user
        const defaultUser: User = {
            id: 'guest',
            name: 'Guest User',
            username: 'guest',
            email: '',
            role: 'user',
            permissions: [],
            avatar: 'assets/images/avatars/male-01.jpg',
            status: 'offline',
        };

        this._permissionService.loadFromUser(defaultUser);
        this._user.next(defaultUser);
        return of(defaultUser);
    }

    /**
     * Update the user
     */
    update(user: User): Observable<any> {
        this.user = user;
        return of(user);
    }
}
